import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { IconSystemV2ArrowChevronRightArrowRight } from '@doltech/icons/SystemV2/IconSystemV2ArrowChevronRightArrowRight';
import { colorsV2 } from '../../colors-v2';

const Container = styled.div`
  display: flex;
  align-items: center;

  &.primary {
    color: ${colorsV2.primary40};
  }

  &.blue {
    color: ${colorsV2.blue40};
  }

  &.black {
    color: ${colorsV2.neutral60};
  }

  &.purple {
    color: ${colorsV2.purple40};
  }

  &.active {
    color: ${colorsV2.neutral60};
  }
`;

interface BreadcrumbItemArrowProps {
  colorStyle?: 'primary' | 'blue' | 'black' | 'purple';
  active?: boolean;
}

export const BreadcrumbItemArrow = (props: BreadcrumbItemArrowProps) => {
  const { colorStyle, active = false } = props;

  return (
    <Container className={cl('breadcrumb-item-arrow', colorStyle, { active })}>
      <IconSystemV2ArrowChevronRightArrowRight size={12} />
    </Container>
  );
};
